// Put your application javascript here
async function addAndOpenCart(id, quantity, properties) {
  await bloom
    .shoppingCart()
    .add([{ id: id, quantity: quantity, properties: properties || {} }]);
  await bloom.reloadCart();
  bloom.showCart();
}

function decrimentValue(item) {
  if (
    parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) > 1
  ) {
    item.parentNode.querySelectorAll("input[type=text]")[0].value = (
      parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) -
      1
    ).toString();
  }
}
function incrimentValue(item) {
  item.parentNode.querySelectorAll("input[type=text]")[0].value = (
    parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) + 1
  ).toString();
}
function addtoCart(v_id, item) {
  addAndOpenCart(
    v_id,
    item.parentNode.querySelectorAll("input[type=text]")[0].value
  );
  if (item.parentNode.querySelectorAll("input[type=text]")[0].value == "") {
    item.parentNode.querySelectorAll("input[type=text]")[0].value = 1;
  }
}
function handlebtn(e, button_link) {
  if (e.keyCode == 13) {
    window.location.href = button_link;
  }
}

function setFullImageHeight() {
  var screen_height = window.innerHeight;
  var navbar_height = document.getElementById("shopify-section-navbar").offsetHeight;
  if (document.getElementById("shopify-section-announcement") != null) {
    var announcement_height = document.getElementById("shopify-section-announcement").offsetHeight;
    var set_height = screen_height - (announcement_height + navbar_height);
  } else {
    var set_height = screen_height - navbar_height;
  }
  var full_height = set_height + "px";
  var el_list = document.getElementsByClassName("full_img");
  for (var i = 0; i < el_list.length; i++) {
    el_list[i].style.height = full_height;
    el_list[i].style.maxHeight = "fit-content";
  }
}

window.addEventListener("load", function () {
 
    if(document.getElementById("signup-form") != null && document.getElementById("signup-form") != undefined) 
    {
    var dataattributes = JSON.parse(document.getElementById("signup-form").getAttribute("data-params"));
    console.log(dataattributes);
    console.log(dataattributes.welcomePagePath);
    if(getCookie("direct-sale-manager") && getCookie("direct-sale-manager-utm"))  
    {
     dataattributes.welcomePagePath = dataattributes.welcomePagePath+"?"+getCookie("direct-sale-manager-utm");
     document.getElementById("signup-form").setAttribute("data-params",JSON.stringify(dataattributes,null, "\t"));
    }
    }
    
     function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
   fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      if(data.item_count>0){
        document.getElementById('cart-counter').classList.remove("hidden")
        document.getElementById('cart-counter').classList.add("flex")
      }else{
        document.getElementById('cart-counter').classList.add("hidden")
      }
       document.getElementById('cart-counter').innerHTML= data.item_count
    });
  setFullImageHeight()
  setTimeout(function() {
    const headerLoader = document.querySelectorAll('.hear-loader');
    if(headerLoader.length>0) {
      headerLoader.forEach((el) => {
        el.style.display = "none";
      })
    }
  },2000);
});

window.addEventListener("resize", function (event) {
  setFullImageHeight()
}, true);

const crypt = (salt, text) => {
  return CryptoJS.AES.encrypt(text, salt)
};

const decrypt = (salt, text) => {
 return CryptoJS.AES.decrypt(text, salt).toString(CryptoJS.enc.Utf8);
}; 
 
function splitLastOccurrence(str, substring) {
  const lastIndex = str.lastIndexOf(substring);
  const before = str.slice(0, lastIndex);
  const after = str.slice(lastIndex + 1);
  return [before, after];
}

function getMonthName(monthNumber) {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString('en-US', {
    month: 'long',
  });
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
  }
  return false;
};
